import React from 'react';

interface AvatarProps {
  firstName?: string;
  lastName?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  shape?: 'circle' | 'rounded' | 'square';
  className?: string;
}

const sizeClasses = {
  xs: 'h-6 w-6 text-xs',
  sm: 'h-10 w-10 text-sm',
  md: 'h-12 w-12 text-base',
  lg: 'h-16 w-16 text-lg',
  xl: 'h-32 w-32 text-4xl',
};

const shapeClasses = {
  circle: 'rounded-full',
  rounded: 'rounded-lg',
  square: 'rounded',
};

export function Avatar({firstName, lastName, name, size = 'md', shape = 'circle', className = ''}: AvatarProps) {
  // Get initials from either firstName+lastName or name
  const getInitials = () => {
    if (firstName && lastName) {
      return `${firstName[0]}${lastName[0]}`.toUpperCase();
    }

    if (name) {
      const parts = name.trim().split(' ');
      if (parts.length >= 2) {
        return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    }

    return '??';
  };

  return (
    <div
      className={`
        ${sizeClasses[size]} 
        ${shapeClasses[shape]} 
        bg-gradient-to-br from-blue-400 to-blue-600 
        flex items-center justify-center 
        text-white font-semibold
        ${className}
      `}
    >
      {getInitials()}
    </div>
  );
}
